const pathObj = {
  loginUser: "/v1/admin/login",
  refreshToken: "/v1/admin/refresh-token",
  profileList: "/v1/admin/profile-list",
  downLineList: "/v1/admin/downline-list",
  addProfile: "/v1/admin/add-profile",
  addOffer: "/v1/admin/add-update-offer",
  getOffer: "/v1/admin/get-offer",
  EditProfile: "/v1/admin/edit-profile",
  updateAccess: "/v1/admin/edit-access",
  metaData: "/v1/admin/meta-data",
  refreshAmount: "/v1/admin/refresh-amount",
  refreshExposureAmount: "/v1/admin/refresh-exposure-amount",
  userProfile: "/v1/admin/profile",
  activityLog: "/v1/admin/activity-logs",
  updateMatchOddsListingStatus: "/v1/admin/sport/match-on-off",
  transactionLogs: "/v1/admin/transaction/logs",
  checkLimit: "/v1/admin/transaction/check-limit",
  updateLimit: "/v1/admin/match/get-match-limit-by-eventid",
  transactionBetLogs: "/v1/admin/transaction/bet-logs",
  getInternationalCasinoBets: "/v1/admin/bets/casono-bet-history",
  settlementList: "/v1/admin/settlement-list",
  transactionSettle: "/v1/admin/transaction/settlement",
  matchList: "/v1/admin/match/add-match-list",
  updateAllAddMatchList: "/v1/admin/match/update-multiple",
  bookmakerOdds: "/v1/cron/bookmaker-odds",
  changePassword: "/v1/admin/change-password",
  updateMatchStatus: "/v1/admin/match/update-status",
  depositChips: "/v1/admin/deposit-chips",
  LotteryResult: "/v1/admin/bet-result/lottery",
  getPremiumFancy: "/v1/cron/premium-fancy",
  getMatchOdds: "/v1/cron/match-odds",
  reportMatch: "/v1/admin/report/match",
  matchBet: "/v1/admin/report/match-bet",
  searchUser: "/v1/admin/search-user",
  profileChangeStatus: "/v1/admin/profile-change-status",
  sportList: "/v1/admin/sport/list",
  updateSportStatus: "/v1/admin/sport/update-status",
  updateMatch: "/v1/admin/match/update-match",
  bankingCreate: "/v1/admin/transaction/create",
  riskListAll: "/v1/admin/match/risk-profile-list-all",
  createWebsite: "/v1/admin/create-website",
  listWebsite: "/v1/admin/list-website",
  userMessageCreate: "/v1/admin/message",
  userMessageList: "/v1/admin/message/list",
  userMessageDetail: "/v1/admin/message/detail",
  userMessageUpdate: "/v1/admin/message/update",
  importantMessage: "/v1/admin/message/important",
  messageStatusUpdate: "/v1/admin/message/status-update",
  updateUserReferenceAmount: "/v1/admin/update-reference-amount",
  updateUserWithdrawAmount: "/v1/admin/update-withdraw-amount",
  updateAwcLimit: "/v1/admin/update-awc-limit",
  getBetslive: "/v1/admin/bets/live-bet-list",
  getBets: "/v1/admin/bets/bet-list",
  withdrawal: "/v1/admin/withdrawal-amount",
  updateBetsStatus: "/v1/admin/bets/update-bet-status",
  rejectedBets: "/v1/admin/bets/rejected-bet-list",
  updateStatusRequestBets: "/v1/admin/match/update-status/",
  getFancyBetsDetails: "/v1/admin/match/detail",
  updateRefrelCode: "/v1/admin/update-referal-code",
  userSMSList: "/v1/admin/sms-list",
  updateSettingLimit: "/v1/admin/match/update-match-limit-by-eventid",
  updateLimit: "/v1/admin/match/get-match-limit-by-eventid",
  updateDefaultSetting: "/v1/admin/settings/global-limit-setting-update",
  getDefaultSetting: "/v1/admin/settings/global-limit-setting-list",
  beforeInplayLimit: "/v1/admin/settings/before-inplay-limit",
  siteSettingUpdate: "/v1/admin/site-setting/site-setting-update",
  matchFilterList: "/v1/admin/match/filter-list",
  fancyList: "/v1/admin/match/fancy-list",
  // resultFancyPremiumList: "/v1/admin/match/result-fancy-premium-list",
  resultFancyPremiumList: "/v1/admin/match/result-fancy-premium-list-new",
  eventFancyBets: "/v1/admin/bets/event-fancy-bets",
  fancyBetResult: "/v1/admin/bet-result/fancy",
  premiumFancyBetResult: "/v1/admin/bet-result/sportBook",
  tossBetResult: "/v1/admin/bet-result/toss",
  promotionalOffer: "/v1/admin/promotional-offer",
  getpromotionalOffer: "/v1/admin/get-promotional-offer",
  deleteFancy: "/v1/admin/match/fancy-delete",
  getExpouserData: "/v1/admin/exposure-list",
  updateExposure: "/v1/admin/update-exposure",
  updateCommission: "/v1/admin/update-commission",
  resultsSetMarker: "/v1/admin/match/lottery-match-list",
  getgameControl: "/v1/admin/get-game-control",
  allUser: "/v1/admin/all-user-list",
  allUserPending: "/v1/admin/all-pending-user-list",

  updateStatusBank: "/v1/admin/update-bank-status",
  addMatchAds: "/v1/admin/match/add-match-ad",
  betHistory: "/v1/admin/bets/bet-history",
  eventsBets: "/v1/admin/bets/events-bets",
  resultsSetMarkerMatch: "/v1/admin/match/result-match-list",
  betProfitLoss: "/v1/admin/bets/profit-loss-bet",
  messageList: "/v1/admin/message/downline?type=downline",
  betfairResult: "/v1/admin/bet-result/betfair",
  tieResult: "/v1/admin/bet-result/tie",
  bookmakerResult: "/v1/admin/bet-result/bookmaker",
  resultTieandAbonded: "/v1/admin/match/update-status-by-eventid",
  reportDownline: "/v1/admin/report/downline",
  reportDownlineDetail: "/v1/admin/report/downline-list",
  reportMarketDetail: "/v1/admin/report/match-market",
  reportMatchMarketBets: "/v1/admin/report/match-market-bets",
  ACasinoprofitAndLossDownlineNew: "/v1/admin/report/casino-profit-loss",
  reportMarket: "/v1/admin/report/market",
  casinoMarket: "/v1/admin/report/casino",
  aprofitCasino: "/v1/admin/report/casino-profit-loss-by-date",
  setBookmaker: "/v1/cron/match-bookmaker-list-save",
  setFancy: "/v1/cron/match-fancy-list-save",
  setFancyupdate: "/v1/cron/fancy-list-save",
  setBookmakerUpdate: "/v1/cron/bookmaker-list-save",
  blockmarketList: "/v1/admin/tournament/series",
  updateBlockListinStatus: "/v1/admin/tournament/block-market",
  updateSportsListingStatus: "/v1/admin/sport/update-status",
  riskProfile: "/v1/admin/risk-profile-list",  dashboard: "/v1/admin/dashboard",
  riskManagementDetails: "/v1/admin/match/detail",
  riskManagementSPortPremiumDetails: "/v1/admin/match/risk-premium-list-book",
  riskmanagemantToss: "/v1/admin/match/risk-toss-match-list",
  riskmanagemantLottery: "/v1/admin/match/risk-lottery-match-list",
  riskManagementFancy: "/v1/admin/match/risk-fancy-list",
  riskManagementPremium: "/v1/admin/match/risk-lottery-list",
  updateFancyStatus: "/v1/admin/match/update-fancy-status",
  updatePremiumFancyStatus: "/v1/admin/match/update-premiumfancy-status",
  downlineDataRisk: "/v1/admin/match-profile-list",
  fancyPosition: "/v1/admin/match/fancy-bet-position",
  depositAmount: "/v1/admin/deposit-amount",
  lockedUserList: "/v1/admin/locked-user-list",
  userProfitLoss: "/v1/admin/profit-loss",
  riskMatchListBookmaker: "/v1/admin/match/risk-bookmaker-match-list",
  riskMatchList: "/v1/admin/match/risk-match-list",
  matchProfitLoss: "/v1/admin/match-profit-loss",
  userEventsBets: "/v1/admin/bets/user-events-bets",
  preMatchEventsBets: "/v1/admin/bets/prematch-events-bets",
  eventSessionBets: "/v1/admin/bets/event-session-bets",
  withdrawCasinoAmount: "/v1/wallet/agent-withdraw",
  tournamentList: "/v1/cron/tournament-list",
  cricketTournamentMatch: "/v1/cron/cricket-tournament-match",
  tennisTournamentMatch: "/v1/cron/tennis-tournament-match",
  soccerTournamentMatch: "/v1/cron/soccer-tournament-match",
  casinoHistory: "/v1/wallet/transaction-list",
  casinoWalletHistory: "/v1/wallet/transaction-history",
  updateWebsiteSetting: "/v1/admin/update-website-setting",
  getWebsiteLinkData: "/v1/admin/website-setting",
  getAECasinoBets: "/v1/admin/transaction/ae-casino-transaction",
  UserLiveBet: "/v1/admin/bets/bet-list-live",
  getFancyOdds: "/v1/cron/fancy-odds",
  withdrwaRequestList: "/v1/admin/agent-withdrawal-history",
  withdrwaRequestListNew: "/v1/admin/withdrawal-request-list",

  //new routes
  reportByDownline: "/v1/admin/report/bydownline",
  casinoAllMarket: "/v1/admin/report/all-casino",
  ICasinoprofitAndLossDownlineNew:
    "/v1/admin/report/international-casino-profit-loss",
  seriesList: "/v1/user/match/series",
  matchDetail: "/v1/user/match/detail",
  blockCasinoList: "/v1/admin/sport/get-casino-market",
  updateBlockCasinoStatus: "/v1/admin/sport/casino-block-market",
  bannerList: "/v1/admin/banner-list",
  deleteBanner: "/v1/admin/delete-banner",
  uploadBanner: "/v1/admin/banner-upload",
  addBanner: "/v1/admin/add-banner",
  reciptUpload: "/v1/admin/qr-upload",
  sendOTP: "/v1/admin/send-otp",
  otpVerify: "v1/admin/verify-otp",
  walletDeposit: "/v1/admin/deposit-list",
  walletWithdrwal: "/v1/admin/withdrawal-list",
  agentList: "/v1/admin/agent-list",
  getagentList: "/v1/admin/get-agent-list",
  userList: "/v1/admin/get-user-list",
  submitAgentTransfer: "/v1/admin/user-transfer",
  agentListBySuperagent: "/v1/admin/agent-list-by-super-agent",
  saveDefaultAgent: "/v1/admin/save-default-agent",
  updateTransaction: "/v1/admin/update-transaction-status",
  updateTransactionNew: "/v1/admin/update-agent-transaction-status",
  updateTransactionId: "/v1/admin/update-transaction-id",
  reciptUploadNew: "/v1/user/receipt-upload",
  getBankList: "/v1/admin/bank-list",
  addEditBank: "/v1/admin/add-edit-bank",
  deletBank: "/v1/admin/delete-bank",
  notificationCount: "/v1/admin/notification-count",
  walletHistory: "/v1/admin/withdrawal-history",
  agentWithdrawHistory: "/v1/admin/downline-withdrawal-history",
  depositHistory: "/v1/admin/deposit-history",

  commisionReport: "/v1/admin/commision-report",
  withdrawalCheck: "/v1/admin/withdrawal-check",
  getcasinoControl: "/v1/admin/get-casio-control",
  getMatchDetailPosition: "/v1/admin/match/bet-postions?eventId=",
  getMatchDetailFancyPosition:
    "/v1/admin/match/fancy-bet-run-position?eventId=",
  gameControl: "/v1/admin/game-control",
  casinoControl: "/v1/admin/casio-control",
  sportSetting: "/v1/admin/sport-setting",

  reportPlayer: "/v1/admin/report/player",
  reportAura: "/v1/admin/report/auracasino",
  reportAuraGamePlList: "/v1/admin/report/auracasino-game-pl-list",
  reportAuraPlayerPl: "/v1/admin/report/auracasino-player-pl",
  reportAuraGamePl: "/v1/admin/report/auracasino-game-pl",

  reportInternational: "/v1/admin/report/internationalcasino",
  reportInternationalPlayerPl: "/v1/admin/report/internationalcasino-player-pl",
  reportInternationalGamePl: "/v1/admin/report/internationalcasino-game-pl",

  reportGap: "/v1/admin/report/gapcasino",
  reportGapPlayerPl: "/v1/admin/report/gapcasino-player-pl",
  reportGapGamePl: "/v1/admin/report/gapcasino-game-pl",

  lifeTimePL: "/v1/admin/lifetime-PL",
  userEventsBetsDetail: "/v1/admin/report/match-bet-detail",
  fancyPositionAdmin: "/v1/admin/match/fancy-bet-run-position",
  sportSetting: "/v1/admin/sport-setting",
  getSportSettingNew: "/v1/admin/get-sport-setting",
};
export default pathObj;
